import { get, filter, map, includes, forEach } from "lodash";

export const isUserRoleConcerned = (policy, publishers, userRoles) => {
  const policyRoles = map(
    get(
      filter(
        get(
          filter(
            publishers,
            (pub) => get(pub, ["id"]) === get(policy, ["publisher", "id"])
          ),
          [0, "series"]
        ),
        (s) => get(s, ["id"]) === get(policy, ["publisher", "serie"])
      ),
      [0, "roles"]
    ),
    (r) => r.toLowerCase()
  );

  let concerned = false;
  if (includes(policyRoles, "*")) {
    concerned = true;
  } else {
    forEach(userRoles, (r) => {
      if (includes(policyRoles, get(r, ["name_en"]).toLowerCase())) {
        concerned = true;
      }
    });
  }
  return concerned;
};

// Return the remaining time to accept a policy or 0 if the delay is over
export const remainingPolicyTime = (policy) => {
  const complianceDeferral = get(policy, ["compliance", "compliance-deferral"]);
  let remainingTime = 0;
  if (complianceDeferral === "0") {
    remainingTime = 0;
  } else {
    const deferralParse = complianceDeferral.split(/(\d+)/);
    const deferralNb = get(deferralParse, [1]);
    const deferralType = get(deferralParse, [2]);
    const dayMiliSeconds = 86400000;
    let endDeferralDate = new Date(get(policy, ["published"])).getTime();
    if (deferralType === "d") {
      endDeferralDate += deferralNb * dayMiliSeconds;
    } else if (deferralType === "w") {
      endDeferralDate += deferralNb * 7 * dayMiliSeconds;
    }

    if (endDeferralDate < Date.now()) {
      remainingTime = 0;
    } else {
      remainingTime = endDeferralDate - Date.now();
    }
  }
  return remainingTime;
};
